import * as React from "react"
import { useNavigate } from "react-router-dom"

import {
  AppBar,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@podcastsoundboard/ps-lib/ui"

import { useAppSelector } from "../../redux"
import DarkModeToggle from "../DarkModeToggle"
import AppBarItems from "./AppBarItems"

interface AppBarComponentProps {
  title?: string
  invert?: boolean
  showLogo?: boolean
  typographyColorOverride?: "white"
}

const AppBarComponent: React.FC<AppBarComponentProps> = (props) => {
  const navigate = useNavigate()
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  const { title, invert, typographyColorOverride, showLogo } = props

  const appBarStyle = invert
    ? {
        backgroundColor: "rgba(0,0,0,0)",
        boxShadow: "none",
      }
    : {}

  const typographyColor =
    typographyColorOverride || (invert ? "primary" : "inherit")

  const isSmallScreen = useMediaQuery("(max-width: 640px)")

  return (
    <AppBar
      position="absolute"
      color={darkModeEnabled ? "default" : "primary"}
      className="z-[1201]"
      style={appBarStyle}
    >
      <Toolbar className="pr-[24px]">
        <>
          {showLogo && (
            <img
              alt=""
              role="presentation"
              onClick={() => navigate("/app")}
              style={{
                height: "3rem",
                marginRight: "1rem",
                cursor: "pointer",
              }}
              src="/logo192.png"
            />
          )}
          <Typography
            component="h1"
            variant="h6"
            color={typographyColor}
            noWrap
            className="grow"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/app")}
          >
            {isSmallScreen ? <>&nbsp;</> : title}
          </Typography>
          <DarkModeToggle />
        </>

        <AppBarItems />
      </Toolbar>
    </AppBar>
  )
}

export default AppBarComponent
